import * as React from "react";
const SvgFiRrTire = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tire_svg__a)">
      <path
        fill="#062147"
        d="M12 0A12.013 12.013 0 0 0 0 12c.6 15.9 23.4 15.893 24 0A12.013 12.013 0 0 0 12 0m0 22A10.01 10.01 0 0 1 2 12c.5-13.248 19.5-13.245 20 0a10.01 10.01 0 0 1-10 10m0-18a8.01 8.01 0 0 0-8 8c.376 10.588 15.626 10.585 16 0a8.01 8.01 0 0 0-8-8m-.834 9.086a4.2 4.2 0 0 0-.444-1.577c.483-.19.919-.482 1.278-.856.358.374.793.666 1.275.856q-.187.367-.3.764a4 4 0 0 0-.144.813 4.1 4.1 0 0 0-1.665 0m5.954-4.212-1.93.772A1.6 1.6 0 0 1 13 8.163V6.084a6.02 6.02 0 0 1 4.12 2.79M11 6.084v2.079a1.6 1.6 0 0 1-2.19 1.483l-1.93-.772A6.02 6.02 0 0 1 11 6.084M6 12q0-.642.135-1.269l1.7.681a2.127 2.127 0 0 1 .914 3.253l-1.1 1.463A5.98 5.98 0 0 1 6 12m3.247 5.33L10.4 15.8a2.06 2.06 0 0 1 3.2 0l1.149 1.531a6.04 6.04 0 0 1-5.502-.001m7.1-1.2-.656-.873-.442-.59a2.128 2.128 0 0 1 .914-3.255l1.7-.681a6.03 6.03 0 0 1-1.516 5.399"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tire_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTire;
